import jq from "jquery";
window.jQuery = jq;
window.$ = jq;

$(function () {
  loadScript(
    "https://cdn.jsdelivr.net/npm/select2@4.0.11/dist/js/select2.min.js",
    () => {
      loadCSS(
        "https://cdn.jsdelivr.net/npm/select2@4.0.11/dist/css/select2.min.css"
      );
    }
  );
});

function loadScript(src, callback) {
  const script = document.createElement("script");
  script.src = src;
  document.body.appendChild(script);
  script.onload = callback;
}

function loadCSS(href) {
  const link = document.createElement("link");
  link.href = href;
  link.rel = "stylesheet";
  document.head.appendChild(link);
}

window.initializeSelects = function () {
  $(".select2").select2({
    language: {
      noResults: function () {
        return "Nenhum resultado encontrado";
      },
      searching: function () {
        return "Pesquisando...";
      },
    },
  });
};
